"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var I18nPriceFormatClientImpl = /** @class */ (function () {
    function I18nPriceFormatClientImpl(configSet) {
        this.configSet = configSet;
    }
    I18nPriceFormatClientImpl.prototype.getCurrencyFormat = function (context, weblabContext) {
        return this.configSet.getObject("currency_format", context === null || context === void 0 ? void 0 : context.toRawContext(), weblabContext);
    };
    I18nPriceFormatClientImpl.prototype.getSymbolPrefix = function (context, weblabContext) {
        return this.configSet.getString("symbol_prefix", context === null || context === void 0 ? void 0 : context.toRawContext(), weblabContext);
    };
    I18nPriceFormatClientImpl.prototype.getTrailingZeroDisplay = function (context, weblabContext) {
        return this.configSet.getObject("trailing_zero_display", context === null || context === void 0 ? void 0 : context.toRawContext(), weblabContext);
    };
    I18nPriceFormatClientImpl.prototype.getCurrencySymbolPosition = function (context, weblabContext) {
        return this.configSet.getObject("currency_symbol_position", context === null || context === void 0 ? void 0 : context.toRawContext(), weblabContext);
    };
    return I18nPriceFormatClientImpl;
}());
exports.default = I18nPriceFormatClientImpl;
